import { useEffect, useState } from 'react';
import { winnerCards } from '../../data/winners';

const moreProjects = winnerCards
  .filter((winner) => winner.id !== 'winner-1996')
  .filter((winner) => {
    const media = winner.media.toLowerCase();
    return media.includes('sculpture');
  })
  .slice(0, 4);

export default function YunHeeMin() {
  const slides = [
    { src: '/uploads/2016/11/yunhee1.jpg', alt: 'Yunhee Min work 1' },
    { src: '/uploads/2016/11/yunhee2.jpg', alt: 'Yunhee Min work 2' },
    { src: '/uploads/2016/11/yunhee3.jpg', alt: 'Yunhee Min work 3' },
    { src: '/uploads/2016/11/yunhee4.jpg', alt: 'Yunhee Min work 4' },
  ];
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      setActiveSlide((currentSlide) => (currentSlide + 1) % slides.length);
    }, 3500);

    return () => window.clearInterval(intervalId);
  }, [slides.length]);

  return (
    <section className="portfolio-item-page">
      <div className="mx-auto max-w-7xl px-5 py-10 md:px-8">
        <h1 className="subheading uppercase">Yunhee Min</h1>

        <div className="portfolio-item-intro">
          <div className="portfolio-item-gallery">
            <div className="portfolio-item-slideshow">
              <div className="portfolio-item-slideshow-frame" aria-label="Yunhee Min slideshow">
                {slides.map((slide, index) => (
                  <img
                    key={slide.src}
                    className={`portfolio-item-slide ${index === activeSlide ? 'portfolio-item-slide-active' : ''}`}
                    src={slide.src}
                    alt={slide.alt}
                    aria-hidden={index !== activeSlide}
                  />
                ))}
              </div>
              <div className="portfolio-item-slideshow-dots" aria-label="Slideshow progress">
                {slides.map((slide, index) => (
                  <button
                    key={slide.src}
                    type="button"
                    className={`portfolio-item-dot ${index === activeSlide ? 'portfolio-item-dot-active' : ''}`}
                    onClick={() => setActiveSlide(index)}
                    aria-label={`Show slide ${index + 1}`}
                    aria-pressed={index === activeSlide}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="portfolio-item-description">
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1.25rem', padding: '0 0' }}>1996</p>

            {/* <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '2rem 0 0', fontWeight: '700'}}>Juror's Statement</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '0 0' }}>TODO</p> */}

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '3rem 0 0', fontWeight: '700' }}>Jurors</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Howard Fox, Curator of LACMA</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Ann Goldstein, Curator of MOCA</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Peter Frank, Chief Editor of The Magazine, Senior Curator of Riverside Museum.</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '3rem 0 0', fontWeight: '700' }}>Biography</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', paddingBottom: '2rem' }}>Yunhee Min (b. 1964 Seoul) received her BFA from the Art Center College of Design in Pasadena, California, and also attended the Kunstakademie in Düsseldorf, Germany. Recent exhibitions include the Museum of Contemporary Art in San Diego, Susanne Vielmetter LA Projects in Los Angeles, ACME in Los Angeles, and the Seattle Art Museum. She is represented by Susanne Vielmetter LA Projects in Los Angeles. Min lives and works in Los Angeles.</p>

            <a href='https://www.yunheemin.com/' className='nav-link'>Artist's Website</a>
          </div>
        </div>
      </div>

      <section className="portfolio-item-more-projects w-full" aria-labelledby="more-projects-heading">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
          <h2 className="subheading" id="more-projects-heading" style={{ marginBottom: '1.5rem' }}>
            More projects
          </h2>
        </div>

        <div className="winners-grid portfolio-item-more-grid">
          {moreProjects.map((winner) => (
            <a
              key={winner.id}
              href={winner.href}
              className="winner-card"
              aria-label={`${winner.year} ${winner.media} by ${winner.name}`}
            >
              <img className="winner-card-image" src={winner.image} alt="" />
              <div className="winner-card-overlay">
                <div className="winner-card-portrait-wrap">
                  <img className="winner-card-portrait" src={winner.portrait} alt="" />
                </div>
                <div className="winner-card-copy">
                  <span className="winner-card-meta">
                    {winner.year} | {winner.media}
                  </span>
                  <span className="winner-card-name">{winner.name}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </section>
    </section>
  );
}
